module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d2c5248bcb745cf10d1223d05c66fb11.png";